module.exports = __webpack_public_path__ + "static/media/coronavirus.5ff74099.mp3";